<div class="QualityEvaluationsContainer w-100 h-100">
    <div class="gridItemChildModule w-100 h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">
        <div *ngIf="!noData" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
            <cxone-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()"
                class="cxone-widget-search" name="cxoneInput-{{moduleKey}}" (ngModelChangeDebounced)="filterValue"
                [ngModelChangeDebounceTime]="500"></cxone-text-input>
            <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>

        <sol-inline-notification *ngIf="isLimitNotificationShown"
            style="margin-top: -12px !important;"
            class="ml-2 mr-2"
            type="info"
            [message]="limitNotificationMessage"
            [show]="isLimitNotificationShown"
            (close)="closeLimitNotification()">
        </sol-inline-notification>

        <div *ngIf="dataLoadSuccess && !noData && gridOptions !== null" class="table-container w-100 h-100">
            <cxone-grid class="content-container w-100 h-100" 
                id="quality-evaluation-grid" [gridOptions]="gridOptions">
            </cxone-grid>
        </div>
    </div>
    <app-module-error class="flex-fill" *ngIf="noData" [noData]="true"></app-module-error>
</div>
